<div class="executions-container">

    <!-- Um agente autonomo sem alTable nao tem onde gravar a fila, entao nao ha
         o que mostrar aqui: e configuracao faltando, nao ausencia de execucao -->
    @if (!agent?.alTable) {
        <nz-alert nzType="warning" nzShowIcon
            [nzMessage]="'agentBuilder.executions.noTable'|translateTA"
            [nzDescription]="'agentBuilder.executions.noTableHint'|translateTA">
        </nz-alert>
    } @else {

        <div class="executions-toolbar">

            <button nz-button nzType="default" (click)="carregar()" [nzLoading]="carregando">
                <nz-icon nzType="reload"></nz-icon>
                {{'agentBuilder.executions.refresh'|translateTA}}
            </button>

            <nz-select [(ngModel)]="filtroDeSituacao" class="executions-filter">
                <nz-option nzValue="todas" [nzLabel]="'agentBuilder.executions.filter.all'|translateTA"></nz-option>
                <nz-option nzValue="running" [nzLabel]="'agentBuilder.executions.status.running'|translateTA"></nz-option>
                <nz-option nzValue="pending" [nzLabel]="'agentBuilder.executions.status.pending'|translateTA"></nz-option>
                <nz-option nzValue="completed" [nzLabel]="'agentBuilder.executions.status.completed'|translateTA"></nz-option>
                <nz-option nzValue="error" [nzLabel]="'agentBuilder.executions.status.error'|translateTA"></nz-option>
                <nz-option nzValue="paused" [nzLabel]="'agentBuilder.executions.status.paused'|translateTA"></nz-option>
            </nz-select>

            <span class="executions-count">
                {{execucoesFiltradas.length}} {{'agentBuilder.executions.runs'|translateTA}}
            </span>

        </div>

        @if (carregando) {
            <nz-spin nzSimple class="executions-spin"></nz-spin>
        } @else if (execucoesFiltradas.length === 0) {
            <nz-empty [nzNotFoundContent]="'agentBuilder.executions.empty'|translateTA"></nz-empty>
        } @else {

            <!-- Uma linha por disparo do cron. Os objetivos ficam dentro,
                 porque um disparo executa todos os objetivos do agente -->
            @for (execucao of execucoesFiltradas; track execucao.sessionId) {

                <div class="execution-card">

                    <div class="execution-header" (click)="alternarExecucao(execucao)">

                        <nz-icon [nzType]="execucao.aberta ? 'down' : 'right'"></nz-icon>

                        <nz-tag [nzColor]="corDaSituacao(execucao.situacao)">
                            {{rotuloDaSituacao(execucao.situacao)|translateTA}}
                        </nz-tag>

                        <span class="execution-date">
                            {{ dataLegivel(execucao.iniciadaEm) | date:'dd/MM/yyyy HH:mm:ss' }}
                        </span>

                        <span class="execution-goals">
                            {{execucao.objetivos.length}} {{'agentBuilder.executions.goals'|translateTA}}
                        </span>

                    </div>

                    @if (execucao.aberta) {
                        <div class="execution-body">

                            <nz-table nzSize="small" nzBordered
                                [nzData]="execucao.objetivos"
                                [nzShowPagination]="false"
                                #tabelaObjetivos>

                                <thead>
                                    <tr>
                                        <th>{{'agentBuilder.executions.goal'|translateTA}}</th>
                                        <th nzWidth="110px">{{'agentBuilder.executions.situation'|translateTA}}</th>
                                        <th nzWidth="80px">{{'agentBuilder.executions.step'|translateTA}}</th>
                                        <th nzWidth="150px">{{'agentBuilder.executions.updatedAt'|translateTA}}</th>
                                        <th nzWidth="90px"></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    @for (objetivo of tabelaObjetivos.data; track objetivo._id) {
                                        <tr>
                                            <td>{{objetivo.goal}}</td>
                                            <td>
                                                <nz-tag [nzColor]="corDaSituacao(objetivo.status)">
                                                    {{rotuloDaSituacao(objetivo.status)|translateTA}}
                                                </nz-tag>
                                            </td>
                                            <td>{{objetivo.step}}</td>
                                            <td>{{ dataLegivel(objetivo.updatedAt) | date:'dd/MM/yyyy HH:mm' }}</td>
                                            <td>
                                                <button nz-button nzType="link" nzSize="small"
                                                    (click)="abrirDetalhe(objetivo)">
                                                    {{'agentBuilder.executions.details'|translateTA}}
                                                </button>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </nz-table>

                        </div>
                    }

                </div>
            }
        }
    }

</div>


<!-- ============================================================
     Detalhe de um objetivo
     ============================================================ -->
<nz-drawer
    [nzVisible]="detalheAberto"
    [nzWidth]="620"
    [nzTitle]="'agentBuilder.executions.detailTitle'|translateTA"
    (nzOnClose)="fecharDetalhe()">

    <ng-container *nzDrawerContent>
        @if (objetivoSelecionado) {

            <nz-descriptions nzBordered nzSize="small" [nzColumn]="1">

                <nz-descriptions-item [nzTitle]="'agentBuilder.executions.goal'|translateTA">
                    {{objetivoSelecionado.goal}}
                </nz-descriptions-item>

                <nz-descriptions-item [nzTitle]="'agentBuilder.executions.situation'|translateTA">
                    <nz-tag [nzColor]="corDaSituacao(objetivoSelecionado.status)">
                        {{rotuloDaSituacao(objetivoSelecionado.status)|translateTA}}
                    </nz-tag>
                </nz-descriptions-item>

                <nz-descriptions-item [nzTitle]="'agentBuilder.executions.startedAt'|translateTA">
                    {{ dataLegivel(objetivoSelecionado.createdAt) | date:'dd/MM/yyyy HH:mm:ss' }}
                </nz-descriptions-item>

                <nz-descriptions-item [nzTitle]="'agentBuilder.executions.updatedAt'|translateTA">
                    {{ dataLegivel(objetivoSelecionado.updatedAt) | date:'dd/MM/yyyy HH:mm:ss' }}
                </nz-descriptions-item>

            </nz-descriptions>

            <!-- O resultado e o motivo do erro sao o que se quer ver aqui;
                 a pilha fica recolhida porque so interessa quando se investiga -->
            @if (objetivoSelecionado.result) {
                <h4 class="execution-section">{{'agentBuilder.executions.result'|translateTA}}</h4>
                <pre class="execution-text">{{objetivoSelecionado.result}}</pre>
            }

            @if (objetivoSelecionado.error) {
                <h4 class="execution-section execution-section-error">
                    {{'agentBuilder.executions.error'|translateTA}}
                </h4>
                <pre class="execution-text execution-text-error">{{objetivoSelecionado.error}}</pre>
            }

            @if (objetivoSelecionado.stackTrace) {
                <nz-collapse class="execution-stack">
                    <nz-collapse-panel [nzHeader]="'agentBuilder.executions.stackTrace'|translateTA" [nzActive]="false">
                        <pre class="execution-text">{{objetivoSelecionado.stackTrace}}</pre>
                    </nz-collapse-panel>
                </nz-collapse>
            }

            @if (objetivoSelecionado.lastMessage) {
                <h4 class="execution-section">{{'agentBuilder.executions.lastMessage'|translateTA}}</h4>
                <pre class="execution-text">{{objetivoSelecionado.lastMessage}}</pre>
            }

            @if (!objetivoSelecionado.result && !objetivoSelecionado.error && !objetivoSelecionado.lastMessage) {
                <nz-empty [nzNotFoundContent]="'agentBuilder.executions.noOutcome'|translateTA"></nz-empty>
            }
        }
    </ng-container>
</nz-drawer>
